module.exports = __webpack_public_path__ + "img/visual_heroes_lossless.bbf9c641.png";